import { createContext, useContext } from 'react';
import PageStore from '../store/PageStore';

const pageStore = new PageStore();

const PageContext = createContext({ pageStore });

export function PageProvider({ children }) {
    return (
        <PageContext.Provider value={{ pageStore }}>
            {children}
        </PageContext.Provider>
    );
}

export function usePageContext() {
    const ctx = useContext(PageContext);
    return ctx || null;
}
